import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/ContactUs.css';

const ContactUs = () => {
  const { t } = useTranslation();
  const address = "Soğanlık Yeni Mah. Pamukkale Sk. No:11 Kartal - İstanbul";
  const encodedAddress = encodeURIComponent(address);
  // Kartal, İstanbul koordinatları (yaklaşık)
  const latitude = 40.9075;
  const longitude = 29.1956;
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

  return (
    <section id="contact" className="contact-us">
      <div className="contact-container">
        <h2 className="contact-title">{t('contact.title')}</h2>
        
        <div className="contact-content">
          {/* Sol Taraf - İletişim Bilgileri */}
          <div className="contact-info">
            <div className="info-card">
              <div className="info-icon-wrapper">
                <svg className="info-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 5C3 3.89543 3.89543 3 5 3H8.27924C8.70967 3 9.09181 3.27543 9.22792 3.68377L10.7257 8.17721C10.8831 8.64932 10.6694 9.16531 10.2243 9.38787L7.96701 10.5165C9.06925 12.9612 11.0388 14.9308 13.4835 16.033L14.6121 13.7757C14.8347 13.3306 15.3507 13.1169 15.8228 13.2743L20.3162 14.7721C20.7246 14.9082 21 15.2903 21 15.7208V19C21 20.1046 20.1046 21 19 21H18C9.71573 21 3 14.2843 3 6V5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="info-content">
                <h3 className="info-label">{t('contact.phone')}</h3>
                <div className="info-values">
                  <a href="tel:+902165045655" className="info-value">+90 216 504 56 55</a>
                  <a href="tel:+905464082722" className="info-value">+90 546 408 27 22</a>
                </div>
                <p className="info-note">{t('contact.phoneNote')}</p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon-wrapper">
                <svg className="info-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="info-content">
                <h3 className="info-label">{t('contact.email')}</h3>
                <a href="mailto:info@experilabs.com" className="info-value">info@experilabs.com</a>
                <p className="info-note">{t('contact.emailNote')}</p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon-wrapper">
                <svg className="info-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="info-content">
                <h3 className="info-label">{t('contact.address')}</h3>
                <p className="info-value address-text">Soğanlık Yeni Mah. Pamukkale Sk. No:11<br />Kartal - İstanbul</p>
              </div>
            </div>
          </div>

          {/* Sağ Taraf - Harita */}
          <div className="contact-map">
            <iframe
              src={`https://www.openstreetmap.org/export/embed.html?bbox=${longitude - 0.01},${latitude - 0.01},${longitude + 0.01},${latitude + 0.01}&layer=mapnik&marker=${latitude},${longitude}`}
              width="100%"
              height="100%"
              style={{ border: 0, borderRadius: '12px' }}
              loading="lazy"
              title="Owlex Location"
            />
            <div className="map-overlay">
              <a 
                href={googleMapsUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="map-link"
              >
                {t('contact.viewOnGoogleMaps')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;

